/** Hirer light theme palette used by StudentResumeView (primary chips, text, surfaces). */
import { createTheme } from "@mui/material/styles";

export const hirerResumeTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#4168a3",
      light: "#e8f0fc",
      dark: "#2d4f7c",
    },
    secondary: { main: "#b85450" },
    background: {
      default: "#f5f6f8",
      paper: "#ffffff",
    },
    text: {
      primary: "#1a1a2e",
      secondary: "#555555",
    },
    divider: "rgba(0, 0, 0, 0.12)",
    action: {
      hover: "rgba(0, 0, 0, 0.04)",
    },
  },
  typography: {
    // Resume Paper overrides to Arial; keep Jura for any theme-tied typography
    fontFamily: "'Jura', Arial, Helvetica, sans-serif",
  },
});
